import StorageNearYou from 'assets/images/psp/storage-near-you/storage-near-you.svg';

function getTitles(type, state, city) {
	switch (type) {
		case 'Electricity':
			return {
				main: `Self Storage with ${type}: Browse More Locations`,
				nearBy: `More Self Storage with ${type} in Nearby Cities`,
				byState: `More Self Storage with ${type} Across ${state}`,
				states: `More Self Storage with ${type} in Major Cities`,
			};
		case 'Facility':
			return {
				main: `Find Self Storage Near You`,
				nearBy:
					city && state
						? `Self Storage in Cities Near ${city}, ${state}`
						: `Self Storage in Nearby Cities`,
				byState: state
					? `Self Storage in ${state}`
					: `Self Storage in Your Area`,
				states: `Self Storage in Other Popular Cities`,
			};
		case 'StorageSize':
			return {
				main: `Find Storage Near You`,
				nearBy: city
					? `Storage facilities near ${city}`
					: `Storage facilities in nearby cities`,
				byState: state
					? `Storage facilities in ${state}`
					: `Storage facilities in your area`,
				states: `Storage facilities across the country`,
			};
		default:
			return {
				main: `${type} Self Storage: Browse More Locations`,
				nearBy: `More ${type} Self Storage in Nearby Cities`,
				byState: `More ${type} Self Storage Across ${state}`,
				states: `More ${type} Self Storage in Major Cities`,
			};
	}
}

export const StorageNearYouData = (type = '', state = '', city = '') => {
	const titles = getTitles(type, state, city);
	return {
		title: titles.main,
		image: StorageNearYou,
		nearByDetectedCities: {
			title: titles.nearBy,
			cities: [],
		},
		citiesByState: {
			title: titles.byState,
			cities: [],
		},
		statesLink: {
			title: titles.states,
			cities: [
				{
					slug: '/self-storage/new-york/new-york/',
					name: 'New York, NY',
				},
				{
					slug: '/self-storage/california/los-angeles/',
					name: 'Los Angeles, CA',
				},
				{
					slug: '/self-storage/texas/houston/',
					name: 'Houston, TX',
				},
				{
					slug: '/self-storage/massachusetts/boston/',
					name: 'Boston, MA',
				},
				{
					slug: '/self-storage/texas/austin/',
					name: 'Austin, TX',
				},
				{
					slug: '/self-storage/nevada/las-vegas/',
					name: 'Las Vegas, NV',
				},
				{
					slug: '/self-storage/florida/miami/',
					name: 'Miami, FL',
				},
				{
					slug: '/self-storage/washington/seattle/',
					name: 'Seattle, WA',
				},
				{
					slug: '/self-storage/colorado/denver/',
					name: 'Denver, CO',
				},
				{
					slug: '/self-storage/georgia/atlanta/',
					name: 'Atlanta, GA',
				},
			],
		},
	};
};
